<template>
  <v-row no-gutters class="w-100 pd-2 control" align="center" justify="center">
    <!-- <v-tooltip top>
      <template v-slot:activator="{ on, attrs}">
        <span v-bind="attrs" v-on="on">{{ name }}</span>
      </template>
      <h5 class="text-right process-name mb-0 mr-3 align-self-center">{{ name }}</h5>
    </v-tooltip> -->
    <h5 class="text-right process-name mb-0 mr-3 align-self-center">{{ name }}</h5>
    <v-btn
      class="align-self-center mr-3"
      color="#033e8c"
      fab
      small
      dark
      :width="buttonWidth"
      :height="buttonWidth"
      @click="$emit('click')"
      >
      <v-icon small>mdi-chevron-double-right</v-icon>
    </v-btn>
  </v-row>  
</template>

<script>
export default {
  name: "ProcessMenuItem",
  props: {
    definitionKey: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    buttonWidth: {
      type: [Number, String],
      default: 45
    }
  },
  data () {
    return {

    }
  }
}
</script>

<style scoped>
.control {
  height: 4rem;
}

.process-name {
  width: calc(100% - 45px - 32px); /** 32px for margins and paddings, 45px for buttonWidth */
  font-size: 1.125rem;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>